import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Label } from "sprout-ui-dom/dist/Form";
import { Box, Flex, Text } from "sprout-ui-primitives";
const StyledInput = styled("input")`
  margin: auto;
`;
const TopicSettingsPageFormSwitch = (props)=>{
    const { id , name , labelText , onChange , description , checked  } = props;
    const inputId = `${id}-input`;
    const labelId = `${id}-label`;
    return /*#__PURE__*/ _jsxs(Flex, {
        children: [
            /*#__PURE__*/ _jsx(Flex, {
                width: "18px",
                height: "18px",
                children: /*#__PURE__*/ _jsx(StyledInput, {
                    checked: checked,
                    type: "checkbox",
                    id: inputId,
                    name: name,
                    onChange: onChange
                })
            }),
            /*#__PURE__*/ _jsxs(Box, {
                ml: "16px",
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        htmlFor: inputId,
                        id: labelId,
                        children: labelText
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        color: "black.60",
                        fontSize: "15px",
                        lineHeight: "20px",
                        mt: "4px",
                        children: description
                    })
                ]
            })
        ]
    });
};
export default TopicSettingsPageFormSwitch;
